// Helper i18n del bundle del theme login facturadirecta.v3.
//
// Lee mensajes pre-resueltos por el server desde `window.kc_messages` y
// hace sustitución simple de placeholders `{0}`, `{1}`, ... con los
// argumentos pasados.
//
// El template.ftl emite `window.kc_messages` justo antes de cargar el
// bundle, con las keys que el bundle consume (mantenidas a mano en una
// lista del FTL — ver delete-credential.ftl o template.ftl).
//
// Si una key no está en window.kc_messages, devolvemos la key tal cual
// (degradación visible: el usuario ve el nombre de la key en lugar del
// texto, lo que hace fácil detectar olvidos en code review).
//
// Ver themes/facturadirecta.v3/src/login/I18N.md para el procedimiento
// de añadir keys nuevas.

declare global {
  interface Window {
    kc_messages?: Record<string, string>;
  }
}

export function msg(key: string, ...args: string[]): string {
  const tpl = window.kc_messages?.[key];
  if (tpl == null) {
    // No emit warning a console: KC también renderiza el texto literal
    // de la key cuando falta, así que mantenemos paridad. La detección
    // se hace por code review + QA.
    return key;
  }
  if (args.length === 0) return tpl;
  return args.reduce(
    (s, v, i) => s.split(`{${i}}`).join(v),
    tpl,
  );
}
